import { NavItem } from "../models/navItem";

const navigationConfig: NavItem[] = [
  {
    path: "/",
    name: "Home",
    component: "",
    public: true,
    roles: [],
    icon: "home",
    navigation: ["main"],
    order: { main: 1 },
  },

  /* Authenticated pages */
  {
    path: "/plannen",
    name: "Plannen",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"], // MSAL roles
    icon: "map",
    navigation: ["main"],
    order: { main: 11 },
  },
  {
    path: "/dossiers",
    name: "Afstemmingsdossiers",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"], // MSAL roles
    icon: "work",
    navigation: ["main"],
    order: { main: 14 },
  },
  {
    path: "",
    name: "divider",
    component: "",
    public: true,
    roles: [],
    navigation: ["main"],
    order: { main: 17 },
  },
  {
    path: "",
    name: "Informatie",
    component: "title",
    public: true,
    roles: [],
    navigation: ["main"],
    order: { main: 18 },
  },
  {
    path: "/over",
    name: "Over infraplannen.nl",
    component: "",
    public: true,
    roles: [],
    icon: "info",
    navigation: ["main"],
    order: { main: 20 }
  },
  {
    path: "/contact",
    name: "Contact",
    component: "",
    public: true,
    roles: [],
    icon: "feedback",
    navigation: ["main"],
    order: { main: 30 },
  },
  {
    path: "https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628588545/Gebruikershandleiding+infraplannen.nl",
    name: "Handleiding",
    component: "",
    public: true,
    roles: [],
    icon: "menu_book",
    navigation: ["main"],
    order: { main: 40 }
  },

  /* Header */

  {
    path: "",
    name: "divider",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    navigation: ["header"],
    order: { header: 38 },
  },
  {
    path: "",
    name: "Mijn",
    component: "title",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    navigation: ["header"],
    order: { header: 39 },
  },
  {
    path: "/mijn/gegevens",
    name: "Mijn gegevens",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    icon: "person",
    navigation: ["header"],
    order: { header: 40 },
  },
  {
    path: "/mijn/organisaties",
    name: "Mijn organisaties",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    icon: "list",
    navigation: ["header"],
    order: { header: 42 },
  },
  // {
  //   path: "/mijn/organisatie/${organisatie.id}",
  //   name: "Mijn organisatie",
  //   component: "",
  //   public: false,
  //   roles: ["Admin", "KeyUser", "User"],
  //   icon: "domain",
  //   navigation: ["header"],
  //   order: { header: 44 },
  // },
  {
    path: "",
    name: "divider",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    navigation: ["header"],
    order: { header: 44 },
  },
  {
    path: "",
    name: "Administratie",
    component: "title",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    navigation: ["header"],
    order: { header: 45 },
  },
  {
    path: "/organisaties",
    name: "Organisaties",
    component: "",
    public: false,
    roles: ["Admin"],
    icon: "security",
    navigation: ["header"],
    order: { header: 46 },
  },
  {
    path: "/samenwerkingsverbanden",
    name: "Samenwerkingsverbanden",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    icon: "groups",
    navigation: ["header"],
    order: { header: 47 },
  },
  {
    path: "",
    name: "divider",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser"],
    navigation: ["header"],
    order: { header: 48 },
  },
  {
    path: "",
    name: "Plannen",
    component: "title",
    public: false,
    roles: ["Admin", "KeyUser"],
    navigation: ["header"],
    order: { header: 49 },
  },
  {
    path: "/mijn/plannen/importeren",
    name: "Plannen importeren",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser"],
    icon: "upload",
    navigation: ["header"],
    order: { header: 50 },
  },
  {
    path: "/mijn/plannen/delen",
    name: "Plannen delen",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser"],
    icon: "share",
    navigation: ["header"],
    order: { header: 52 },
  },
  {
    path: "",
    name: "divider",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser"],
    navigation: ["header"],
    order: { header: 60 },
  },
  {
    path: "",
    name: "Kaartlagen",
    component: "title",
    public: false,
    roles: ["Admin", "KeyUser"],
    navigation: ["header"],
    order: { header: 61 },
  },
  {
    path: "/mijn/kaartlagen/importeren",
    name: "Kaartlagen importeren",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser"],
    icon: "upload",
    navigation: ["header"],
    order: { header: 62 },
  },
  {
    path: "/mijn/kaartlagen",
    name: "Kaartlagen",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser"],
    icon: "layers",
    navigation: ["header"],
    order: { header: 63 },
  },
  {
    path: "/mijn/kaartlagen/zichtbaarheid",
    name: "Zichtbaarheid kaartlagen",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser"],
    icon: "visibility",
    navigation: ["header"],
    order: { header: 64 },
  },

  // In/uitloggen
  {
    path: "",
    name: "divider",
    component: "",
    public: true,
    roles: [],
    navigation: ["main", "header"],
    order: { main: 98, header: 98 },
  },
  {
    path: "/inloggen",
    name: "Inloggen",
    component: "",
    public: true,
    roles: [],
    icon: "lock_open",
    navigation: ["main", "header"],
    order: { main: 99, header: 99 },
    hideWhenAuthenticated: true,
  },
  {
    path: "/uitloggen",
    name: "Uitloggen",
    component: "",
    public: false,
    roles: ["Admin", "KeyUser", "User", "ReadOnly"],
    icon: "logout",
    navigation: ["main", "header"],
    order: { main: 100, header: 100 },
  },

  // Sitemap
  {
    path: "",
    name: "Informatie",
    component: "",
    public: true,
    roles: [],
    icon: "info",
    navigation: ["sitemap"],
    order: { sitemap: 1 },
    children: [
      {
        path: "/over",
        name: "Over infraplannen.nl",
        component: "",
        public: true,
        roles: [],
        icon: "",
        navigation: ["sitemap"],
        order: { sitemap: 1 },
      },
      {
        path: "/over-integraal-programmeren",
        name: "Over integraal programmeren",
        component: "",
        public: true,
        roles: [],
        icon: "",
        navigation: ["sitemap"],
        order: { sitemap: 2 },
      },
      {
        path: "https://status.infraplannen.nl/",
        name: "Deelnemende organisaties",
        component: "",
        public: true,
        roles: [],
        icon: "",
        navigation: ["sitemap"],
        order: { sitemap: 3 },
      },
      {
        path: "/kosteloos-gebruik",
        name: "Kosteloos gebruik",
        component: "",
        public: true,
        roles: [],
        icon: "",
        navigation: ["sitemap"],
        order: { sitemap: 4 },
      }
    ]
  },
  {
    path: "",
    name: "Direct naar",
    component: "",
    public: true,
    roles: [],
    icon: "directions",
    navigation: ["sitemap"],
    order: { sitemap: 2 },
    children: [
      {
        path: "/toegang-als-organisatie",
        name: "Hoe krijgt mijn organisatie toegang?",
        component: "",
        public: true,
        roles: [],
        icon: "",
        navigation: ["sitemap"],
        order: { sitemap: 1 },
      },
      {
        path: "/veelgestelde-vragen",
        name: "Veelgestelde vragen",
        component: "",
        public: true,
        roles: [],
        icon: "help",
        navigation: ["sitemap"],
        order: { sitemap: 2 },
      },
      {
        path: "https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628588545/Gebruikershandleiding+infraplannen.nl",
        name: "Handleiding",
        component: "",
        public: true,
        roles: [],
        icon: "menu_book",
        navigation: ["sitemap"],
        order: { sitemap: 5 }
      },
    ]
  },
  {
    path: "",
    name: "Contact",
    component: "",
    public: true,
    roles: [],
    icon: "feedback",
    navigation: ["sitemap"],
    order: { sitemap: 3 },
    children: [
      {
        path: "/contact",
        name: "Contactgegevens",
        component: "",
        public: true,
        roles: [],
        icon: "",
        navigation: ["sitemap"],
        order: { sitemap: 1 },
      },
      {
        path: "/over-mijnaansluiting",
        name: "Over Stichting Mijn Aansluiting",
        component: "",
        public: true,
        roles: [],
        icon: "",
        navigation: ["sitemap"],
        order: { sitemap: 2 },
      }
    ]
  },

  // Footer
  {
    path: "/algemene-voorwaarden",
    name: "Algemene voorwaarden",
    component: "",
    public: true,
    roles: [],
    icon: "info",
    navigation: ["footer"],
    order: { footer: 2 },
  },
  {
    path: "/privacy",
    name: "Privacyverklaring",
    component: "",
    public: true,
    roles: [],
    icon: "contract",
    navigation: ["footer"],
    order: { footer: 1 },
  },
];

export default navigationConfig;
